module.exports = __webpack_public_path__ + "img/blog-7-4.73d7f021.webp";